import {Injectable} from '@angular/core';
import {Project} from '../model/project';
import {Questionnaire} from '../model/questionnaire';
import {Synchro} from '../model/synchro';
import {Email} from '../model/email/email';
import {Statistics} from '../model/statistics';
import {ServerAddress} from '../util/server-address';
import {Client} from '../model/client';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Sms} from '../model/sms/sms';
import {User} from '../model/user';
import {ImportRequirement} from '../model/import-requirement';
import {Ftp} from '../model/ftp';
import {FacebookTwitterJson} from '../model/facebookTwitterJson';
import {ServerConfig} from '../model/ServerConfig';
import {SmsConfig} from '../model/smsConfig';
import {FacebookAPIConfig} from '../model/FacebookAPIConfig';
import {Table} from '../model/database/table';
import {TwitterAPIConfig} from '../model/TwitterAPIConfig';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {Device} from '../model/device';
import {Observer} from 'rxjs/internal/types';
import {DynamicDataRequestConfig} from '../model/dynamicData/dynamicDataRequestConfig';
import {PurgeModel} from '../model/Purge/purgeModel';
import {observableToBeFn} from 'rxjs/internal/testing/TestScheduler';


@Injectable()
export class ProjectService {
    private projectsUrl = 'projects/';
    private projectsUrlClient = 'client-projects';
    private respondentsUrl = 'respondents/';
    private questionnaireUrl = 'questionnaire/';
    private emailDetailsUrl =  'email-details/';
    private emailBucketsUrl = 'email-bucket/';
    private statisticsUrl = 'statistics/';
    private getResourceUrl = 'getSource/';
    private runPostSyncUrl = 'executePostSync/';
    // TODO: remove this url if not using it. Remove it upon confrmation
    private downloadUrl = 'download/';
    private downloadPreviewContentUrl = 'downloadProject/';
    private excelReportUrl = 'excel-report/';
    private updateRespondentUrl = 'update-respondent/';
    private updateProjectUrl = 'update-project/';
    private updateQuestionnaireUrl = 'update-questionnaire/';
    private updateTerminalUrl = 'update-terminal/';
    private deleteRespondentUrl = 'delete-respondent/';
    private deleteSynchroUrl = 'delete-synchro/';
    private sendEmailUrl = 'send-email/';
    private createProjectUrl = 'create-project/';
    private uploadFileUrl = 'upload-project-file/';
    private createQuestionnaireUrl = 'create-questionnaire/';
    private createTerminalUrl = 'create-terminal/';
    private createClientUrl = 'create-client/';
    private clientsUrl = 'clients/';
    private projectUrl = 'project/';
    private sendCreateSynchroUrl = 'send-synchro';
    private removeFileUrl = 'remove-file/';
    private removeTerminalUrl = 'remove-terminal/';
    private nbRepondantUrl = 'nb-respondents/';
    private respondentsByRangeUrl = 'respondents-by-range/';
    private respondentUrl = 'respondent/';
    private createEmailUrl = 'create-email/';
    private getEmailModelUrl = 'getEmailModel/';
    private generateEmailpreviewUrl = 'generateHTMLEmail/';
    private createSmsUrl = 'create-sms/';
    private sendSmsUrl = 'send-sms/';
    private getEmailPreviewUrl = 'viewEmail/';
    private smsDetailsUrl =  'sms-details/';
    private deleteProjectUrl = 'delete-project/';
    private deleteQuestionnaireUrl = 'delete-questionnaire/';
    private createUserUrl = 'create-user';
    private removeUserUrl = 'remove-user/';
    private modifyUserUrl = 'modify-user/';
    private ftpConfigureUrl = 'configure-ftp/';
    private getConfigurationUrl = 'getConfiguration/';
    private serverConfigureUrl = 'configure-server/';
    private twillioConfigureUrl = 'configure-sms/';
    private facebookConfigureUrl = 'configure-facebook/';
    private twitterConfigureUrl = 'configure-twitter/';
    private galleryImageLinks = 'imageGalleryLinks/';
    private micrositeConfigure = 'micrositeConfiguration/';
    private PostFacebookTwitterJsonConfig = 'facebookTwitterConfig/';
    private getFacebookTwitterJsonConfig = 'getFacebookTwitterConfig/';
    private getMicrositeJsonConfig = 'getMicrositeConfiguration/';
    private micrositePreviewUrl = 'projects/web/';
    private uploadDatabaseCreation = 'pushDatabaseCreation/';
    private createTableUrl = 'createTable/';
    private updateTableUrl = 'updateTable/';
    private deleteTableUrl = 'deleteTable/';
    private dropColumnUrl = 'dropColumn/';
    private getDBDefinitionUrl = 'getDBDefinition/';
    private deleteSmsDefinitionUrl = 'removeSmsDefinition/';
    private deleteEmailDefinitionUrl = 'removeEmailDefinition/';
    private updatePostSyncActionConfig = 'set-post-sync-template/';
    private logUrl = 'logs/';
    private getRegisteredDevices = 'registeredDevices/';
    private getDevicesUsedForTerminal = 'DevicesUsed/';
    private registerDevice = 'registerDevice/';
    private getClientListUrl = 'registeredClients/';
    private removeClientUrl = 'removeClient/';
    private updateClientUrl = 'updateClient/';
    private insertCronJobURL = 'enableCronJob/';
    private removeCronJobURL = 'removeCronJob/';
    private getDynamicDataURL = 'get-respondent-data/';
    private getCronJobURL = 'getCronJob/';
    private getJWTTokenURL = 'getJWTToken';

    private getDataKeysForRespId = '/microsite/datakeys/';


    constructor(private _http: HttpClient) {

    }

    getProjects(): Observable<any> {
        /*return this._http.get(ServerAddress.getInstance().getValue() + this.projectsUrl)
            .toPromise()
            .then(response => {
              // const prj:Project[] = JSON.parse(response.);
                return response as Project[]; // JSON.;
            })
            .catch(this.handleError);*/

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.post(ServerAddress.getInstance().getValue() + this.projectsUrl, {
            headers: headers
        });
    }

    getClientProjects(token): Observable<any> {
        /*return this._http.get(ServerAddress.getInstance().getValue() + this.projectsUrlClient + '?token=' + token)
            .toPromise()
            .then(response => {
                console.log(response);
                return response as Project[];
            })
            .catch(this.handleError);*/

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.post(ServerAddress.getInstance().getValue() + this.projectsUrlClient + '?token=' + token, {
            headers: headers
        });
    }

    handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    getRespondents(qId, searchFilters): Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.post(ServerAddress.getInstance().getValue() + this.respondentsUrl +'-1'+'/'+'-1/'+qId+'/-1', JSON.stringify(searchFilters), {
            headers: headers
        });
    }

    getEmail(projectId,questId,terminalId,terminalType): Observable<any> {
      const headers = new HttpHeaders().append('Content-Type', 'application/json');

      let params = new HttpParams();
      params = params.set('project_id', projectId);
      params = params.set('questionnaire_id',questId);
      params = params.set('terminal_id',terminalId);
      params = params.set('terminalType',terminalType);

      return this._http.get(ServerAddress.getInstance().getValue() + this.emailDetailsUrl, {
        params : params,
        headers: headers
      });

    }

    getEmailBucket(projectId,questId,terminalId,terminalType): Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('project_id', projectId);
        params = params.set('questionnaire_id',questId);
        params = params.set('terminal_id',terminalId);
        params = params.set('terminalType',terminalType);

        return this._http.get(ServerAddress.getInstance().getValue() + this.emailBucketsUrl, {
            params : params,
            headers: headers
        });
    }

    getDynamicData(dynamicDataRequest:DynamicDataRequestConfig):Observable<any> {

        const boundary = '---WebKitFormBoundary7MA4YWxkTrZu0gW';

        const headers = new HttpHeaders().append('Accept', '*/*').append('mock','false');

        const params = new HttpParams();
        const val =Json2TypescriptUtil.getJsonConvertInstance().serializeObject(dynamicDataRequest,DynamicDataRequestConfig);
        console.log(val);
        /*const form = new FormData();
        form.append('request_config', JSON.stringify(dynamicDataRequest));*/
        /*params = params.set('project_id', projectId);
        params = params.set('questionnaire_id',questId);
        params = params.set('terminal_id',terminalId);
        params = params.set('terminalType',terminalType);*/
        return this._http.post(ServerAddress.getInstance().getValue() + this.getDynamicDataURL,dynamicDataRequest,{
            headers: headers
        });
    }

  getSms(projectId,questId,terminalId,terminalType): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('project_id', projectId);
    params = params.set('questionnaire_id',questId);
    params = params.set('terminal_id',terminalId);
    params = params.set('terminalType',terminalType);

    return this._http.get(ServerAddress.getInstance().getValue() + this.smsDetailsUrl, {
      params : params,
      headers: headers
    });
    /*  .toPromise()
      .then(response => {

          const sms =
          return sms;
        // return response as Sms;
      })
      .catch(this.handleError);*/
  }

  executePostSyncOnAllRespondents(pId,qId,tId): Observable<any> {
      const headers = new HttpHeaders().append('Content-Type', 'application/json');

      let params = new HttpParams();
      params = params.set('pId', pId);
      params = params.set('qId',qId);
      params = params.set('tId',tId);

      return this._http.get(ServerAddress.getInstance().getValue() + this.runPostSyncUrl, {
          headers: headers,
          params:params
      });
  }

  getRegisteredClients():Observable<any> {
      const headers = new HttpHeaders().append('Content-Type', 'application/json');

      const params = new HttpParams();
      return this._http.get(ServerAddress.getInstance().getValue() + this.getClientListUrl, {
          headers: headers,
          params:params
      });
  }

    updatedRegisteredClient(client:Client):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        const params = new HttpParams();
        return this._http.put(ServerAddress.getInstance().getValue() + this.updateClientUrl,JSON.stringify(Json2TypescriptUtil.getJsonConvertInstance().serialize(client)),{
            headers: headers,
            params:params
        });
    }

    removeRegisteredClient(id:any):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        const params = new HttpParams();
        params.set('clientID',id);
        return this._http.delete(ServerAddress.getInstance().getValue() + this.removeClientUrl, {
            headers: headers,
            params:params
        });
    }

    getResourceLink(str:any):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');
        let params = new HttpParams();

        params = params.set('reference',String(str));
        return this._http.get(ServerAddress.getInstance().getValue() + this.getResourceUrl, {
            headers: headers,
            params:params,
            responseType: 'text'
        });
    }

    getStatistics(id, searchFilters): Promise<Statistics> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.post(ServerAddress.getInstance().getValue() + this.statisticsUrl + id, JSON.stringify(searchFilters), {
            headers: headers
        })
            .toPromise()
            .then(response => {
                return response  as Statistics;
            })
            .catch(this.handleError);
    }

    getProject(id): Observable<any> {
        /*return this._http.get(ServerAddress.getInstance().getValue() + this.projectUrl + id)
            .toPromise()
            .then(response => {
                return response as Project;
            })
            .catch(this.handleError);*/
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.get(ServerAddress.getInstance().getValue() + this.projectUrl + id, {
            headers: headers
        });

        /*return new Observable((observer).next(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(jsonVal,Project)).complete();*/
    }


    updateRespondent(respondent): Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.put(ServerAddress.getInstance().getValue() + this.updateRespondentUrl, JSON.stringify(Json2TypescriptUtil.getJsonConvertInstance().serialize(respondent)), {
            headers: headers
        });

        /*return this._http.put(ServerAddress.getInstance().getValue() + this.updateRespondentUrl, JSON.stringify(respondent), {
            headers: headers
        })
            .toPromise()
            .then(response => {
                return 'questionnaireProject updated';
            })
            .catch(this.handleError);*/
    }

    updateProject(project): Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.put(ServerAddress.getInstance().getValue() + this.updateProjectUrl, JSON.stringify(project), {
            headers: headers
        });
           /* .toPromise()
            .then(response => {
                return 'project updated';
            })
            .catch(this.handleError);*/
    }

    updateQuestionnaire(questionnaire, project_id): Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('project_id', project_id);
        params = params.set('questionnaire_id',questionnaire.id);

        return this._http.put(ServerAddress.getInstance().getValue() + this.updateQuestionnaireUrl, JSON.stringify(questionnaire), {
            params : params,
            headers: headers
        });
           /* .toPromise()
            .then(response => {
                return 'questionnaireProject updated';
            })
            .catch(this.handleError);*/
    }

    updateTerminalNode(terminal,project_id,questionnaire_id,terminalType_Id,importOpt?:ImportRequirement):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('project_id', project_id);
        params = params.set('terminalType_id',terminalType_Id);
        params = params.set('questionnaire_id',questionnaire_id);

        if(importOpt != null) {
          terminal.importRequirement = importOpt;
        }

        console.log(JSON.stringify(terminal));
        return this._http.put(ServerAddress.getInstance().getValue() + this.updateTerminalUrl, Json2TypescriptUtil.getJsonConvertInstance().serializeObject(terminal), {
            params : params,
            headers: headers
        });
    }

    removeUploadedFile(fileToRemove): Promise<string> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.delete(ServerAddress.getInstance().getValue() + this.removeFileUrl+fileToRemove,
            {
                headers:headers
            })
            .toPromise()
            .then(response => {
                return 'file Removed';
            })
            .catch(this.handleError);
    }

    downloadFile(id, type: string, questionNo: number, searchFilters) {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('type', type);
        params = params.set('no',questionNo.toString());

        return this._http.post(ServerAddress.getInstance().getValue() + this.downloadUrl + id, JSON.stringify(searchFilters), {
            params: params,
            responseType:'blob',
            headers: headers
        });
    }

    downloadPreviewContent(link) {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        const params = new HttpParams();
        /*params = params.set('projectID', pId);
        params = params.set('questionnaireID', qId);
        params = params.set('clientTypeID', typeId);
        params = params.set('fileName', fileName);
        params = params.set('terminalID', tId);*/

        return this._http.get(link, {
            params: params,
            responseType:'text',
            headers: headers
        });
    }


    excelReport(id, searchFilters,reportDefinition) {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');
        /*let params = new HttpParams();
        params = params.set('reportDef', reportDefinition);*/

        return this._http.post(ServerAddress.getInstance().getValue() + this.excelReportUrl + id, JSON.stringify(reportDefinition), {
           // params: params,
            responseType:'blob',
            observe: 'response',
            headers: headers
        });
    }


    deleteRespondent(respondentId): Promise<void> {
        return this._http.delete(ServerAddress.getInstance().getValue() + this.deleteRespondentUrl + respondentId)
            .toPromise()
            .then(response => {
                return;
            });
    }

    deleteSynchro(synchroId): Promise<void> {
        return this._http.delete(ServerAddress.getInstance().getValue() + this.deleteSynchroUrl + synchroId)
            .toPromise()
            .then(response => {
                return;
            });
    }

    removeProject(pId):Observable<any> {
      return this._http.delete(ServerAddress.getInstance().getValue() + this.deleteProjectUrl + pId,{observe:'body'});/*.pipe(map(res=> {
          if(res) {
            console.log(res);
          }
        }
      ));*/
    }

    enableCronJob(pId,qId,purgeModel:PurgeModel): Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('projectID', pId);
        params = params.set('questionnaireID',qId);

        console.log(Json2TypescriptUtil.getJsonConvertInstance().serializeObject(purgeModel,PurgeModel));
        return this._http.put(ServerAddress.getInstance().getValue() + this.insertCronJobURL,Json2TypescriptUtil.getJsonConvertInstance().serializeObject(purgeModel),{params:params,headers:headers});
    }

    getCronJob(pId,qId):Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('projectID', pId);
        params = params.set('questionnaireID',qId);
        return this._http.get(ServerAddress.getInstance().getValue()+this.getCronJobURL,{params:params,headers:headers});
    }

    deleteCronJob(pId,qId):Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('projectID', pId);
        params = params.set('questionnaireID',qId);

        return this._http.delete(ServerAddress.getInstance().getValue() + this.removeCronJobURL,{params:params});
    }

    createUser(user:User):Observable<any> {

        console.log(ServerAddress.getInstance().getValue());
        const headers = new HttpHeaders().append('Content-Type', 'application/json');
      return this._http.put(ServerAddress.getInstance().getValue() + this.createUserUrl,JSON.stringify(user),{
          headers: headers
      });
    }

    removeUser(user:User):Observable<any> {
      return this._http.put(ServerAddress.getInstance().getValue() + this.createUserUrl,JSON.stringify(user)).pipe(map(res=> {
          if(res) {
            console.log(res);
          }
        }
      ));
    }

    modifyUser(user:User):Observable<any> {
      return this._http.put(ServerAddress.getInstance().getValue() + this.createUserUrl,JSON.stringify(user)).pipe(map(res=> {
          if(res) {
            console.log(res);
          }
        }
      ));
    }


    sendEmail(project_id,questionnaire_id,terminal_id, terminalType_Id,emailAddr,lang,respondentToken,path): Observable<any> {
      const headers = new HttpHeaders().append('Content-Type', 'application/json');

      let params = new HttpParams();
      params = params.set('projectID', project_id);
      params = params.set('questionnaireID',questionnaire_id);
      params = params.set('terminalID',terminal_id);
      params = params.set('terminalType',terminalType_Id);
      params = params.set('emailAddr',emailAddr);
      params = params.set('language',lang);
      params = params.set('respondentToken',respondentToken);
        params = params.set('path',path);

      return this._http.get(ServerAddress.getInstance().getValue() + this.sendEmailUrl, {
        params : params,
        headers: headers
      });
    }


    createProject(project,duplicate:any):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');
      let params = new HttpParams();
      if(duplicate!=null) {
          params = params.set('duplicate',duplicate);
      } else {
          params = params.set('duplicate',duplicate);
      }
        return this._http.post(ServerAddress.getInstance().getValue() + this.createProjectUrl,JSON.stringify(project), {
            params:params,
            headers: headers
        });
    }

    uploadFile(file, projectId, questionnaireId): Promise<any> {
        return new Promise((resolve, reject) => {
        const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

        formData.append('file', file, file.name);
        formData.append('project_id', projectId);
        formData.append('questionnaire_id', questionnaireId);

        xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    } else {
                        reject(xhr.response);
                    }
                }
            };

        xhr.upload.onprogress = (event) => {
            // this.progress = Math.round(event.loaded / event.total * 100);
            console.log(event.loaded / event.total * 100);
            // this.progressObserver.next(this.progress);
        };

        xhr.open('POST', ServerAddress.getInstance().getValue() + this.uploadFileUrl, true);
        xhr.send(formData);
        });
    }

    // by default importRequirement is undefined
    createQuestionnaire(questionnaire,importQuestionnaireInfo?:ImportRequirement):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        const params = new HttpParams();

        if(importQuestionnaireInfo!=null) {
          questionnaire.importRequirement = importQuestionnaireInfo;
        }

        return this._http.post(ServerAddress.getInstance().getValue() + this.createQuestionnaireUrl, JSON.stringify(questionnaire), {
            params: params,
            headers: headers
        });
    }


    createTerminal(terminal,questionnaire_id,importQuestionnaireInfo?:ImportRequirement):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        // params.set('project_id', project_id);
        params = params.set('questionnaire_id',questionnaire_id);

        if(importQuestionnaireInfo!=null) {
          terminal.importRequirement = importQuestionnaireInfo;
        }

        return this._http.post(ServerAddress.getInstance().getValue() + this.createTerminalUrl,Json2TypescriptUtil.getJsonConvertInstance().serializeObject(terminal), {
            params: params,
            headers: headers
        });
    }

    createPostSynchro(postSynchro, idQuestionnaire) {
        // to do server
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.post(ServerAddress.getInstance().getValue() + this.sendCreateSynchroUrl + idQuestionnaire, JSON.stringify(postSynchro), {
            headers: headers
        });
    }

    getQuestionnaire(id): Observable<any> {

        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this._http.get(ServerAddress.getInstance().getValue() + this.questionnaireUrl + id,{

            headers:headers

        });
    }

    createClient(client) {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.put(ServerAddress.getInstance().getValue() + this.createClientUrl, JSON.stringify(client), {
            headers: headers
        });
    }

    getClients(): Promise<Client[]> {
        return this._http.get(ServerAddress.getInstance().getValue() + this.clientsUrl)
            .toPromise()
            .then(response => {
                return response as Client[];
            })
            .catch(this.handleError);
    }

    removeTerminal(terminalId,projectId,questId):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');
        let params = new HttpParams();
        params = params.set('project_id', projectId);
        params = params.set('questionnaire_id',questId);

        return this._http.delete(ServerAddress.getInstance().getValue() + this.removeTerminalUrl+terminalId,{

            headers:headers,
            params:params

        });
    }


    getNbRespondent(qId): Promise<number> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        return this._http.get(ServerAddress.getInstance().getValue() + this.nbRepondantUrl + qId, {
            headers: headers
        })
            .toPromise()
            .then(response => {
                return response as number;
            })
            .catch(this.handleError);
    }



    getRespondentsByRange(start,end,respID,sId,pId,qId,tId,lite,startDate,endDate): Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');
        let params = new HttpParams();
        params = params.append('startIndex', start);
        params = params.append('endIndex', end);
        params = params.append('respId', respID);
        params = params.append('lite',lite);
        params = params.append('minDate',startDate);

        params = params.append('maxDate',endDate);


        return this._http.get(ServerAddress.getInstance().getValue() + this.respondentsByRangeUrl + sId+'/'+pId+'/'+qId+'/'+tId, {
            params: params,
            headers: headers
        });
            /*.subscribe()
            .then(response => {
                return response as Respondent[];
            })
            .catch(this.handleError);*/
    }

    createEmail(email,project_id,questionnaire_id,terminal_id,terminalType_Id): Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('project_id', project_id);
      params = params.set('terminal_id', terminal_id);
        params = params.set('terminalType_id',terminalType_Id);
        params = params.set('questionnaire_id',questionnaire_id);

        return this._http.put(ServerAddress.getInstance().getValue() + this.createEmailUrl, JSON.stringify(email), {
            params : params,
            headers: headers
        });
    }


  createSms(sms,project_id,questionnaire_id,terminal_id,terminalType_Id): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('project_id', project_id);
    params = params.set('terminal_id',terminal_id);
    params = params.set('terminalType_id',terminalType_Id);
    params = params.set('questionnaire_id',questionnaire_id);

    return this._http.put(ServerAddress.getInstance().getValue() + this.createSmsUrl, JSON.stringify(sms), {
      params : params,
      headers: headers
    });
  }

  sendSMS(project_id,questionnaire_id,terminal_id,terminalType,phone,respondentToken,lang): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('projectID', project_id);
    params = params.set('questionnaireID',questionnaire_id);
    params = params.set('terminalID',terminal_id);
    params = params.set('terminalType',terminalType);
    params = params.set('phoneNumber',phone);
    params = params.set('respondentToken',respondentToken);
    params = params.set('language',lang);

    return this._http.get(ServerAddress.getInstance().getValue() + this.sendSmsUrl, {
      params : params,
      headers: headers
    });
  }

  // TODO: Replace this method with a simpler ersion which on takes a temporary token and valid for microsites and emails
  getEmailPreview(project_id,questionnaire_id,terminal_id,terminalType_Id,previewLang): Observable<string> {
    const headers = new HttpHeaders().append('Content-Type', 'text/plain');

    let params = new HttpParams();
    params = params.set('projectID', project_id);
    params = params.set('questionnaireID',questionnaire_id);
    params = params.set('terminalID',terminal_id);
    params = params.set('terminalType',terminalType_Id);
    params = params.set('previewLang',previewLang);

    return this._http.get(ServerAddress.getInstance().getValue() + this.getEmailPreviewUrl, {
      params : params,
      headers: headers,
      responseType: 'text'   // exlicitement pour recuperer du html tout en evitant d'utiliser le parseur JSON par defaut
    });
  }


    getPreview(token:string,isMail:boolean,path:string,dataKey:string,jwtToken:any): Observable<string> {
        const headers = new HttpHeaders().append('Content-Type', 'text/plain').append('Authorization',jwtToken);

        let params = new HttpParams();
        params = params.set('dataKey', dataKey);
       // params = params.set('path', path);
        path = btoa(path);

        let url = '';
        if(isMail) {
            url = this.getEmailPreviewUrl;
        } else {
            url = this.micrositePreviewUrl;
        }

        return this._http.get(ServerAddress.getInstance().getValue() + url+token+'/'+path,{
            headers: headers,
            params:params,
            responseType: 'text'   // exlicitement pour recuperer du html tout en evitant d'utiliser le parseur JSON par defaut
        });
    }



    /*getEmailModel(project_id,questionnaire_id,terminalType_Id,lang): Promise<Email> {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('project_id', project_id);
        params = params.set('terminalType_id',terminalType_Id);
        params = params.set('questionnaire_id',questionnaire_id);
        params = params.set('language',lang);

        return this._http.get(ServerAddress.getInstance().getValue() + this.getEmailModelUrl, {
            params : params,
            headers: headers
        })
            .toPromise()
            .then(response => {
                return response as Email;
            })
            .catch(this.handleError);

    }

    generateEmailPreview(project_id,questionnaire_id,terminalType_Id,lang,preview):Promise<emailPreview>{
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('project_id', project_id);
        params = params.set('terminalType_id',terminalType_Id);
        params = params.set("questionnaire_id",questionnaire_id);
        params = params.set('language',lang);
        params = params.set('preview',preview);

        return this._http.get(ServerAddress.getInstance().getValue() + this.generateEmailpreviewUrl, {
            params : params,
            headers: headers,
        })
            .toPromise()
            .then(response => {

                return response as emailPreview;
            })
            .catch(this.handleError);
    }*/


    test(project_id,questionnaire_id,terminalType_Id,lang): Observable<string> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('project_id', project_id);
        params = params.set('terminalType_id',terminalType_Id);
        params = params.set('questionnaire_id',questionnaire_id);
        params = params.set('language',lang);

        return this._http.get(ServerAddress.getInstance().getValue() + 'isAlive/',{

            headers: headers,
            responseType:'text'
        })
            .pipe(
            map(response => {
                // return "project updated";
                console.log(response);
                return 'is Alive Verified';
            }),);

    }


  removeQuestionnaire(qId: number):Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('questionnaireID',String(qId));

    return this._http.delete(ServerAddress.getInstance().getValue() + this.deleteQuestionnaireUrl, {
      params : params,
      headers: headers
    });
  }

  // TODO: Think of a way to reassemble all configuration requests into  one single reqeusts
  configureFtp(modelObject: Ftp): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    return this._http.put(ServerAddress.getInstance().getValue() + this.ftpConfigureUrl, JSON.stringify(modelObject), {
      headers: headers
    });
  }

  configureServer(modelObject:ServerConfig): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    return this._http.put(ServerAddress.getInstance().getValue() + this.serverConfigureUrl, JSON.stringify(modelObject), {
      headers: headers
    });
  }

  configureTwilio(modelObject:SmsConfig): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    return this._http.put(ServerAddress.getInstance().getValue() + this.twillioConfigureUrl, JSON.stringify(modelObject), {
      headers: headers
    });
  }

  configureFacebookAPI(modelObject:FacebookAPIConfig): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    return this._http.put(ServerAddress.getInstance().getValue() + this.facebookConfigureUrl, JSON.stringify(modelObject), {
      headers: headers
    });
  }

  configureTwitterAPI(modelObject:TwitterAPIConfig): Observable<any> {

      const headers = new HttpHeaders().append('Content-Type', 'application/json');

      return this._http.put(ServerAddress.getInstance().getValue() + this.twitterConfigureUrl, JSON.stringify(modelObject), {
          headers: headers
      });
  }

  /**
   *
   * @param configName represents the type of configuration: SMS,Facebook,Server,FTP...
   */
  getConfiguration(configName:string): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('configType',configName);

    return this._http.get(ServerAddress.getInstance().getValue()+this.getConfigurationUrl, {
      params : params,
      headers: headers
    });
  }

  getImageGalleryUrls(pId:number,qId:number,folder:string):Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('pId',String(pId));
    params = params.set('qId',String(qId));
    params = params.set('folder',folder);

    return this._http.get(ServerAddress.getInstance().getValue()+this.galleryImageLinks, {
      params : params,
      headers: headers
    });
  }


  createTable(table:Table,project_id,questionnaire_id,terminal_id,terminal_type):Observable<any> {
      const headers = new HttpHeaders().append('Content-Type', 'application/json');

      let params = new HttpParams();
      params = params.set('projectID', project_id);
      params = params.set('questionnaireID',questionnaire_id);
      params = params.set('terminalID',terminal_id);
      params = params.set('terminalType',terminal_type);

      return this._http.put(ServerAddress.getInstance().getValue() + this.createTableUrl, JSON.stringify(table),{
            headers: headers,
            params : params
      });
  }

    alterTable(table:Table,project_id,questionnaire_id,terminal_id,terminal_type):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('projectID', project_id);
        params = params.set('questionnaireID',questionnaire_id);
        params = params.set('terminalID',terminal_id);
        params = params.set('terminalType',terminal_type);

        return this._http.put(ServerAddress.getInstance().getValue() + this.updateTableUrl, JSON.stringify(table),{
            headers: headers,
            params : params
        });
    }


    getDBDefinition(project_id,questionnaire_id,terminal_id,terminal_type):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('projectID', project_id);
        params = params.set('questionnaireID',questionnaire_id);
        params = params.set('terminalID',terminal_id);
        params = params.set('terminalType',terminal_type);

        return this._http.get(ServerAddress.getInstance().getValue() + this.getDBDefinitionUrl,{
            headers: headers,
            params : params
        });
    }




  configureMicrosite(pId:number,qId:number,tId:number,terminalType:number,microsite:string):Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('pId',String(pId));
    params = params.set('qId',String(qId));
    params = params.set('tId',String(tId));
    params = params.set('terminalTypeId',String(terminalType));

    return this._http.post(ServerAddress.getInstance().getValue()+this.micrositeConfigure, microsite,{
      params : params,
      headers: headers
    });
  }

  facebookTwitterConfig(pId:number,qId:number,tId:number,terminalTypeId:number,config:FacebookTwitterJson,isFacebook:boolean):Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('pId',String(pId));
    params = params.set('qId',String(qId));
    params = params.set('tId',String(tId));
    params = params.set('terminalType',String(terminalTypeId));
    params = params.set('isFacebook',String(isFacebook));

    return this._http.post(ServerAddress.getInstance().getValue() + this.PostFacebookTwitterJsonConfig,JSON.stringify(config),{
      params : params,
      headers: headers
    });
  }

  getFacebookTwitterConfig(pId:number,qId:number,tId:number,terminalTypeId:number,isFacebook:boolean):Observable<any>  {

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('pId',String(pId));
    params = params.set('qId',String(qId));
    params = params.set('tId',String(tId));
    params = params.set('terminalType',String(terminalTypeId));
    params = params.set('isFacebook',String(isFacebook));

    return this._http.get(ServerAddress.getInstance().getValue()+this.getFacebookTwitterJsonConfig, {
      params : params,
      headers: headers,
      responseType: 'text'
    });
  }

  getMicrositeConfig(pId:number,qId:number,tId:number,terminalTypeId:number):Observable<any> {

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('pId',String(pId));
    params = params.set('qId',String(qId));
    params = params.set('tId',String(tId));
    params = params.set('terminalTypeId',String(terminalTypeId));

    return this._http.get(ServerAddress.getInstance().getValue()+this.getMicrositeJsonConfig, {
      params : params,
      headers: headers,
      responseType: 'text'
    });

  }

  deleteTable(tableName:string,pId:number,qId:number,tId:number,terminalTypeId:number):Observable<any>  {
      const headers = new HttpHeaders().append('Content-Type', 'application/json');

      let params = new HttpParams();
      params = params.set('table',tableName);
      params = params.set('projectID',String(pId));
      params = params.set('questionnaireID',String(qId));
      params = params.set('terminalID',String(tId));
      params = params.set('terminalType',String(terminalTypeId));

      return this._http.delete(ServerAddress.getInstance().getValue() + this.deleteTableUrl, {
          params : params,
          headers: headers
      });
  }

    dropColumn(tableName:string,colName:string,pId:number,qId:number,tId:number,terminalTypeId:number):Observable<any>  {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('table',tableName);
        params = params.set('column',colName);
        params = params.set('projectID',String(pId));
        params = params.set('questionnaireID',String(qId));
        params = params.set('terminalID',String(tId));
        params = params.set('terminalType',String(terminalTypeId));

        return this._http.delete(ServerAddress.getInstance().getValue() + this.dropColumnUrl, {
            params : params,
            headers: headers
        });
    }


    removeSmsDefinition(pId:number,qId:number,tId:number,terminalTypeId:number):Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('projectID',String(pId));
        params = params.set('questionnaireID',String(qId));
        params = params.set('terminalID',String(tId));
        params = params.set('terminalType',String(terminalTypeId));

        return this._http.delete(ServerAddress.getInstance().getValue() + this.deleteSmsDefinitionUrl, {
            params : params,
            headers: headers
        });
    }


    removeEmailDefinition(pId:number,qId:number,tId:number,terminalTypeId:number,path:string,templateId:string):Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('projectID',String(pId));
        params = params.set('questionnaireID',String(qId));
        params = params.set('terminalID',String(tId));
        params = params.set('terminalType',String(terminalTypeId));
        params = params.set('path',path);
        params = params.set('templateId',templateId);

        return this._http.delete(ServerAddress.getInstance().getValue() + this.deleteEmailDefinitionUrl, {
            params : params,
            headers: headers
        });
    }

    getLogs(name:string):Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'text/plain');

        let params = new HttpParams();
        params = params.set('log',name);

        return this._http.get(ServerAddress.getInstance().getValue() + this.logUrl, {
            params : params,
            headers: headers,
            responseType: 'text'
        });
    }

    listDevicesUsedForATerminal(tID:number):Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        let params = new HttpParams();
        params = params.set('tID',String(tID));

        return this._http.get(ServerAddress.getInstance().getValue() + this.getDevicesUsedForTerminal, {
            params : params,
            headers: headers,
            responseType: 'json'
        });
    }

    listRegisteredDevices():Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        const params = new HttpParams();

        return this._http.get(ServerAddress.getInstance().getValue() + this.getRegisteredDevices, {
            params : params,
            headers: headers,
            responseType: 'json'
        });
    }

    registerADevice(device:Device):Observable<any> {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        const params = new HttpParams();

        return this._http.post(ServerAddress.getInstance().getValue() + this.registerDevice,device, {
            params : params,
            headers: headers,
            responseType: 'text'
        });
    }

    downloadContent(filePath:any): Observable<any> {

        const headers = new HttpHeaders().append('Content-Type', 'application/json');

        const params = new HttpParams();


        return this._http.get(ServerAddress.getInstance().getValue() + filePath, {
            params : params,
            headers: headers,
            responseType: 'blob'
        });
    }


  setEmailTemplateForTerminal(pId:number,qId:number,tId:number,path:string,classId:string): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params = new HttpParams();
    params = params.set('projectID',String(pId));
    params = params.set('questionnaireID',String(qId));
    params = params.set('terminalID',String(tId));
    params = params.set('classID',classId);
    params = params.set('path',path);


    return this._http.post(ServerAddress.getInstance().getValue() + this.updatePostSyncActionConfig, null,{
      params : params,
      headers: headers,
      responseType: 'json'
    });
  }

  getDataKeys(respId:any,token:any):Observable<any> {

    const customHeader = {
      'Content-Type': 'application/json',
      'Authorization':token
    };
    const headers = new HttpHeaders(customHeader);
    let params = new HttpParams();
    params = params.set('respId',respId);


    return this._http.get(ServerAddress.getInstance().getValue() + this.getDataKeysForRespId,{
      params : params,
      headers: headers,
      observe: 'response',
      responseType: 'json'
    });
  }

  getJWTToken() {
    const headers = new HttpHeaders().append('Content-Type', 'html/text');
    return this._http.get(ServerAddress.getInstance().getValue() + this.getJWTTokenURL, {
      headers: headers,
      responseType: 'text'
    });
  }
}

